module.exports = __webpack_public_path__ + "static/img/ydh2-facevalue.90f9f5c0.png";